// export const BASE_URL: string = 'http://localhost:9000/api/';
// export const BASE_URL: string = 'https://seriesbooking-training-dotnet.dev-altamedia.com/api/';
export const BASE_URL: string = 'https://seriesbooking-api.altamedia.vn/api/';
// export const BASE_URL: string = 'http://seriestraining-api.dev-altamedia.com/api/';
// export const BASE_URL: string = 'https://seriesbooking-demo-intelisys.dev-altamedia.com/api/';
// export const BASE_URL: string = 'https://seriesbooking-api.altamedia.vn/api/'

export const TIME_REFRESH_TOKEN: number = 15000;
export const TIME_REFRESH_FARE_RESULT: number = 30;
